// Translations
import landing from '../views/landing/translations/ua'

// Translation: Login (Ukrainian)
export default Object.freeze({
	name: '',
	views: { landing }
})
